export default "__VITE_PUBLIC_ASSET__f4a58c40__"